<template>
    <div>
        <div v-if="type == 'box-game-index'" class="search-game-item" @click="enterBoxGameDetail">
            <div class="left-img">
                <lazy-image :style="{ 'border-radius': '10px' }" :src="filterImg(gameInfo.cover_image_url)"></lazy-image>
            </div>
            <div class="info">
                <div class="game-name ellipsis">
                    {{ gameInfo.goods_name }}
                </div>
                <div class="en-name ellipsis">{{ gameInfo.english_title }}</div>
                <div class="tag ellipsis">
                    <span v-for="(item, index) in tagList" :key="item.id">
                        <span>{{ item.name }}</span>
                        <span class="split" v-if="index < tagList.length - 1">/</span>
                    </span>
                </div>
            </div>
        </div>
        <div v-else class="search-game-item" @click="enterGameDetail">
            <div class="left-img">
                <lazy-image :style="{ 'border-radius': '10px' }" :src="filterImg(gameInfo.cover_image_url)"></lazy-image>
            </div>
            <div class="info">
                <div class="game-name ellipsis">
                    {{ gameInfo.goods_id ? gameInfo.goods_name : gameInfo.title }}
                </div>
                <div class="en-name ellipsis">{{ gameInfo.english_title }}</div>
                <div class="tag ellipsis">
                    <span v-for="(item, index) in gameInfo.tag_List" :key="item.id">
                        <span>{{ item.name }}</span>
                        <span class="split" v-if="index < gameInfo.tag_List.length - 1">/</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        gameInfo: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String,
            default: 'game-index'
        }
    },
    name: 'SearchGameItem',
    computed: {
        tagList() {
            if (this.gameInfo && this.gameInfo.tag_List && Array.isArray(this.gameInfo.tag_List) && this.gameInfo.tag_List.length) {
                return this.gameInfo.tag_List
            }
            return []
        }
    },
    methods: {
        filterImg(value) {
            return this.$Utils.filterImgUrl(value, '276x130')
        },
        enterBoxGameDetail() {
            this.$EventBus.$emit('hide-search')
            let { game_id, title, goods_id } = this.gameInfo
            const game_name = title || this.gameInfo.game_name
            const route = this.$router.resolve({
                path: '/landpage',
                query: {
                    game_id: game_id,
                    goods_id: goods_id
                }
            })
            const newWindow = window.open(route.href, '_blank')

            newWindow.onload = () => {
                newWindow.document.title = route.meta?.title || `乐速盒子官网-${game_name}`
            }
        },
        enterGameDetail() {
            this.$EventBus.$emit('hide-search')
            let goods_id = 0
            let { game_id, boxGoodsList, game_name } = this.gameInfo
            if (Array.isArray(boxGoodsList) && boxGoodsList[0]) {
                goods_id = boxGoodsList[0].id
            }
            const route = this.$router.resolve({
                path: '/landpage',
                query: {
                    game_id: game_id,
                    goods_id: goods_id
                }
            })
            const newWindow = window.open(route.href, '_blank')

            newWindow.onload = () => {
                newWindow.document.title = route.meta?.title || `乐速盒子官网-${game_name}`
            }
        }
    }
}
</script>
<style lang="less" scoped>
.search-game-item {
    height: 80px;
    border-radius: 10px;
    display: flex;
    padding: 10px 0 0 10px;
    cursor: pointer;

    .left-img {
        flex-shrink: 0;
        width: 130px;
        height: 60px;
        border-radius: 10px;
    }

    &:hover {
        background-color: #4b4b4b;
    }

    .info {
        width: 170px;
        margin-left: 10px;

        .game-name {
            color: @color-txt-high;
            font-size: 14px;
            line-height: 14px;
            margin-bottom: 10px;
        }

        .en-name {
            color: @color-txt-normal;
            font-size: 12px;
            height: 14px;
            margin-bottom: 6px;
        }

        .tag {
            color: @color-txt-normal;
            font-size: 12px;
        }
    }
}
</style>
